// src/components/ChordButtons.js
import React, { useEffect, useState } from 'react';
import Soundfont from 'soundfont-player';

const ChordButtons = () => {
  const [piano, setPiano] = useState(null);

  useEffect(() => {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    Soundfont.instrument(ctx, 'acoustic_grand_piano').then(setPiano);
  }, []);

  const playChord = (notes) => {
    if (!piano) return;
    notes.forEach((note) => piano.play(note, 0, { duration: 1.5 }));
  };

  const chords = [
    { name: 'C Maj', notes: ['C4', 'E4', 'G4'] },
    { name: 'G Maj', notes: ['G3', 'B3', 'D4'] },
    { name: 'A min', notes: ['A3', 'C4', 'E4'] },
    { name: 'F Maj', notes: ['F3', 'A3', 'C4'] },
  ];

  return (
    <div style={{ display: 'flex', gap: '10px', marginTop: '20px' }}>
      {chords.map((chord) => (
        <button
          key={chord.name}
          onClick={() => playChord(chord.notes)}
          style={{
            padding: '12px',
            fontSize: '16px',
            borderRadius: '8px',
            cursor: 'pointer',
            background: '#333',
            color: '#fff',
          }}
        >
          {chord.name}
        </button>
      ))}
    </div>
  );
};

export default ChordButtons;
